<template>
    <alert-modal
        :title="titleCopy"
        :superTitle="$t('SWITCH_POP_SUPER')"
        :primaryCTAText="$t('ACTION_OKAY')"
        @close="close"
        @confirm="confirm"
    >
        <div class="cz2__modal-popup__copy">
            {{ bodyCopy }}
        </div>

        <div
            aria-hidden="true"
            class="cz2__switch-pop-wrapper"
        >
            <div
                :style="{ backgroundImage: `url(${pop1PreviewImage})` }"
                class="cz2__switch-pop-snapshot"
            />

            <img
                src="../assets/icons/switch-arrow.svg"
                alt=""
                width="68"
                height="49"
                :class="{ flip: !isFirstPop }"
                class="cz2__switch-pop-arrow"
            >

            <div
                :style="{ backgroundImage: `url(${pop2PreviewImage})` }"
                class="cz2__switch-pop-snapshot"
            />
        </div>
    </alert-modal>
</template>

<style lang="scss">
    #cz2.cz2 {
        .cz2__switch-pop-wrapper {
            display: flex;
            justify-content: center;
            gap: 16px;
        }

        .cz2__switch-pop-snapshot {
            margin-bottom: 16px;

            flex: 1 1 auto;
            aspect-ratio: 675 / 900;

            background-size: contain;
            background-repeat: no-repeat;
        }

        .cz2__switch-pop-arrow {
            align-self: center;

            &.flip {
                transform: scaleX(-1);
            }
        }
    }
</style>

<script>
    import popPlaceholder from '../assets/images/pop-placeholder.png';

    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },

        computed: {
            controller1() {
                return this.$store.getters.popControllers[0];
            },

            controller2() {
                return this.$store.getters.popControllers[1];
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.controller1;
            },

            pop1PreviewImage() {
                return this.$store.state.customizer.popPreviewImageByController[this.controller1.id] ?? popPlaceholder;
            },

            pop2PreviewImage() {
                return this.$store.state.customizer.popPreviewImageByController[this.controller2.id] ?? popPlaceholder;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            titleCopy() {
                return this.isKiosk ? this.titleCopyKiosk : this.titleCopyWeb;
            },

            titleCopyWeb() {
                return this.isFirstPop ? this.$t('SWITCH_POP_TITLE') : this.$t('SWITCH_POP_TITLE_2');
            },

            titleCopyKiosk() {
                return this.isFirstPop ? this.$t('SWITCH_POP_TITLE_KIOSK') : this.$t('SWITCH_POP_TITLE_2_KIOSK');
            },

            bodyCopy() {
                return this.isKiosk ? this.bodyCopyKiosk : this.bodyCopyWeb;
            },

            bodyCopyWeb() {
                return this.isFirstPop ? this.$t('SWITCH_POP_BODY') : this.$t('SWITCH_POP_BODY_2');
            },

            bodyCopyKiosk() {
                return this.isFirstPop ? this.$t('SWITCH_POP_BODY_KIOSK') : this.$t('SWITCH_POP_BODY_2_KIOSK');
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showSwitchPopModal', false);
            },

            confirm() {
                const current = this.$store.state.customizer.viewController;
                const notCurrent = this.$store.getters.popControllers.find((x) => x !== current);
                const startGroup = notCurrent.blueprint.groups.find((g) => g.custom && g.custom['fun-start-group'] === 'true');
                const nameGroup = notCurrent.blueprint.groups.find((g) => g.code === 'Name');
                const targetGroup = this.isFirstPop ? startGroup : nameGroup;

                this.$store.dispatch('selectPop', notCurrent);
                this.$store.dispatch('showGroup', targetGroup);
                this.close();
            },
        },
    };
</script>
